export default "__VITE_ASSET__qGqIrgoo__"